<template>
  <div>
    <div class="app">
      <!--      <transition :name="transitionName">-->
      <keep-alive :include="include" :max="10">
        <router-view class="router" ref="router"></router-view>
      </keep-alive>
      <!--      </transition>-->
    </div>
    <Footer v-if="footer === true"></Footer>
    <Home v-if="home === true"></Home>

    <van-popup v-model="show" lock-scroll :close-on-click-overlay="false" style="border-radius: 10px">
      <div class="show-outer">
        <div class="show-box">
          <div class="title">提示</div>
          <div class="content">
            <span>您即将访问的页面及服务由</span>
            <span class="gs">海尔精选商城（海礼网（北京）智能技术有限公司）</span>
            <span>提供，如有问题请咨询该公司客服（客服电话：400-6777159）</span>
          </div>
          <div>
            <van-checkbox v-model="checked">已知晓，不再提示此信息</van-checkbox>
          </div>
        </div>
        <div class="operate">
          <span class="off" @click="handleOff">取消</span>
          <span class="go" @click="handleGo">继续访问</span>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
function isKeepAlive($route) {
  return $route.meta.keepAlive === undefined || $route.meta.keepAlive;
}

import Footer from "@components/Footer";
import Home from "@components/Home";
import { mapGetters } from "vuex";
import cookie from "@utils/store/cookie";
import { openShareAll } from "@libs/wechat";
import { getShare } from "@api/public";
import { isWeixin } from "@utils/index";

export default {
  data() {
    return {
      transitionName: "fold-right",
      include: isKeepAlive(this.$route) ? [this.$route.name] : [],
      history: [],
      checked: false,
      show: false,
    };
  },
  provide() {
    return {
      app: this,
    };
  },
  computed: mapGetters(["footer", "home", "isLogin"]),
  components: {
    Footer,
    Home,
  },
  watch: {
    $route(to, from) {
      const lastPath = this.history[this.history.length - 1] || {},
        { isReplace, isBack } = this.$router;

      if (lastPath.path === to.path) {
        this.transitionName = "fold-right";
        this.history.pop();
      } else {
        this.transitionName = "fold-left";
        if (!isReplace) this.history.push({ path: from.path, name: from.name });
      }

      if (isKeepAlive(to) && to.name !== "Login") {
        !this.include.includes(to.name) && this.include.push(to.name);
      }

      if (isKeepAlive(from) && isBack) {
        var index = this.include.indexOf(from.name);
        index !== -1 && this.include.splice(index, 1);
      }

      this.$router.isBack = false;
      this.$router.isReplace = false;

      console.log(this.transitionName, "change");
    },
  },
  mounted: function() {
    //弹框是否显示
    let value = JSON.parse(localStorage.getItem("prompt_check"));
    if (value == null) {
      this.show = true;
    } else {
      if (value.expires == "") {
        this.show = false;
      } else {
        let currentTimestamp = Date.now();
        if (currentTimestamp > value.expires) {
          this.show = true;
        } else {
          this.show = false;
        }
      }
    }
    this.setOpenShare();
  },
  methods: {
    setOpenShare: function() {
      if (isWeixin()) {
        getShare().then((res) => {
          var data = res.data.data;
          var configAppMessage = {
            desc: data.synopsis,
            title: data.title,
            link: location.href,
            imgUrl: data.img,
          };
          openShareAll(configAppMessage);
        });
      }
    },
    //取消（关闭浏览器）
    handleOff() {
      setTimeout(function() {
        window.location.href = "mdb://closeWebPage";
      }, 200);
    },
    //继续访问
    handleGo() {
      let value = {
        status: true,
        expires: Date.now() + 86400000,
      };
      if (this.checked == true) {
        value.expires = "";
        localStorage.setItem("prompt_check", JSON.stringify(value));
        // cookie.set("prompt_check", value);
      } else {
        localStorage.setItem("prompt_check", JSON.stringify(value));
        // cookie.set("prompt_check", value);
      }
      this.show = false;
    },
  },
};
</script>
<style lang="scss">
.show-outer {
  .show-box {
    width: 280px;
    font-size: 18px;
    margin: 22px 28px;
    .title {
      font-weight: 600;
      text-align: center; /* 父级设置 */
    }
    .content {
      padding: 16px 0;
      word-break: break-all;
      .gs {
        color: #5383ee;
      }
    }
  }
  .operate {
    color: #5383ee;
    display: flex;
    align-items: center;
    border-top: 1px #ccc solid;
    .off {
      font-size: 16px;
      padding: 10px 0;
      width: 50%;
      text-align: center;
      border-right: 1px #ccc solid;
    }
    .go {
      font-size: 16px;
      font-weight: 600;
      padding: 10px 0;
      width: 50%;
      text-align: center;
    }
  }
}

.show-serve-outer {
  .serve-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px 30px;
    .title {
      text-align: center;
      font-size: 16px;
      font-weight: 600;
      padding-bottom: 18px;
    }
    .tel-box {
      text-align: center;
      padding: 10px;
      width: 100%;
      color: white;
      margin: 10px 0;
      border-radius: 14px;
      background-image: linear-gradient(to right, #fa6514 0%, #e93323 100%);
    }
  }
  .line {
    height: 1px;
    background: #f3f3f3;
  }
  .serve-con-box {
    font-size: 14px;
    padding: 0 20px 20px;
    .con {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .title {
        margin-right: 50px;
      }
      .shou {
        display: flex;
        align-items: center;
      }
      .shou2 {
        display: flex;
      }
    }
  }
}

.router {
  position: absolute;
  width: 100%;
}

.fold-left-enter-active {
  animation-name: fold-left-in;
  animation-duration: 0.5s;
}

.fold-left-leave-active {
  animation-name: fold-left-out;
  animation-duration: 0.5s;
}

.mianxi {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0 !important;
  .m-ico {
    font-weight: normal;
    font-size: 0.2rem;
    padding: 0.08rem;
    border: #f05e51 1px solid;
    border-radius: 5px;
    letter-spacing: 1px;
    margin-right: 30px;
  }
}
.daoshoujia {
  font-weight: normal;
  color: #ccc;
  width: 3.2rem;
}

.detail-money {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: red;
  .vip-money {
    font-size: 16px;
    font-weight: normal;
  }
  .detail-mianxi {
    font-size: 14px;
    font-weight: normal;
    background: red;
    color: #fff;
    padding: 2px;
    margin-left: 10px;
  }
}
.detail-zuigao-num {
  display: flex;
  justify-content: center;
  padding: 2px;
  margin: 12px 0;
  font-size: 0.23rem;
  letter-spacing: 1px;
  margin-left: 0.3rem;
  width: 94px;
  background: #f8ccc8;
  border-radius: 4px;
  color: red;
}

.baozheng-box {
  height: 300px;
  padding: 0 20px;
  .title {
    display: flex;
    justify-content: center;
    padding: 14px;
    font-size: 18px;
    font-weight: 600;
  }
  .item-box {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 20px;
    .img {
      margin-right: 20px;
    }
    .b {
      font-size: 14px;
      color: rgb(149, 149, 149);
    }
  }
}

.detail-shoucang-box {
  display: flex;
  .item {
    width: 120px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-left: 1px #ccc solid;
  }
}

.yugu-daoshou-box {
  display: flex;
  align-items: center;
  font-size: 0.24rem;
  color: #141313;
  font-weight: bold;
  .num {
    font-weight: normal;
    font-size: 0.22rem;
    color: #4c4c4c;
  }
}

@keyframes fold-left-in {
  0% {
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }
  10% {
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }
  100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes fold-left-out {
  0% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  10% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  100% {
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
}

.fold-right-enter-active {
  animation-name: fold-right-in;
  animation-duration: 0.5s;
}

.fold-right-leave-active {
  animation-name: fold-right-out;
  animation-duration: 0.5s;
}

@keyframes fold-right-in {
  0% {
    width: 100%;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
  10% {
    width: 100%;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
  100% {
    width: 100%;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes fold-right-out {
  0% {
    width: 100%;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  10% {
    width: 100%;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  100% {
    width: 100%;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }
}
</style>
